export default __webpack_public_path__ + "static/media/ForBiggerBlazes.4c0fa37e.jpg";